import { render, staticRenderFns } from "./FloatMenuDesktop.vue?vue&type=template&id=79958a08&scoped=true"
import script from "./FloatMenuDesktop.vue?vue&type=script&lang=js"
export * from "./FloatMenuDesktop.vue?vue&type=script&lang=js"
import style0 from "./FloatMenuDesktop.vue?vue&type=style&index=0&id=79958a08&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79958a08",
  null
  
)

export default component.exports